import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSnackbar, Button, Stack, Typography } from '@emburse/embark-core';
import { useState } from 'react';
import { $t } from '../../../../hooks/useTranslation';
import { EmployeeSearch } from '../../../../components';
export default function EmployeeExceptionManager({ auditDefPayload, exceptionDetailType, addExceptions, refreshExceptionDetails, exceptionDetails }) {
    const [employee, setEmployee] = useState({ value: null, validationText: '' });
    const { enqueueSnackbar } = useSnackbar();
    const employeeChangeHandler = (newEmployee) => {
        setEmployee({ validationText: '', value: newEmployee });
    };
    return (_jsxs(Stack, { alignItems: "center", direction: "row", spacing: 1, sx: { width: '100%' }, children: [_jsx(EmployeeSearch, { id: "UserName", label: $t('User Name *'), value: employee.value, helperText: employee.validationText, error: Boolean(employee.validationText), onSelect: employeeChangeHandler, sx: { width: '280px' }, exclusionList: exceptionDetails.map((exception) => exception.TypeID) }), _jsx(Button, { variant: "outlined", sx: { width: '80px' }, disabled: employee.value === null, onClick: async () => {
                    try {
                        await addExceptions({
                            AuditDefPK: auditDefPayload.AuditDefPK,
                            ExceptionType: exceptionDetailType,
                            ExceptionIDs: [employee.value.PK]
                        });
                        await refreshExceptionDetails();
                        enqueueSnackbar($t('Exceptions added successfully'), {
                            variant: 'success'
                        });
                        setEmployee({ value: null, validationText: '' });
                    }
                    catch (error) {
                        enqueueSnackbar($t('Error adding exception'), { variant: 'error' });
                    }
                }, "data-qa": "add-exception-button", children: _jsx(Typography, { color: "inherit", children: $t('Add') }) })] }));
}
